<template>
	<div class="dcom_latest_stories_container">
		
		<story-list
		:cms_list_id = "dcom_stories_uuid"
		></story-list>

	</div>
</template>

<script>
import StoryList from '@/components/lists/story_list.vue'

export default {
	name: 'DcomLatestStories',
	data () {
		return {
			dcom_stories_uuid: '0036de38-28b8-11e9-bab0-a7d3b5289767'
		}
	},
	computed: {
		
	},
	methods: {
		
	},
	components: {
		StoryList
	}
}
</script>

<style lang="scss">

.dcom_latest_stories_container {
	
}

</style>



// WEBPACK FOOTER //
// src/features/cms_content/dcom_latest_stories_list.vue